import React from 'react';
import styled from '@emotion/styled';
import { useRecoilValue } from 'recoil';
import CheckSelfForNumberWithSelect from '../../../../common/checkbox/CheckSelfForNumberWithSelect';
import Span from '../../../../common/text/Span';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';
import { SelfInputForNumber } from '../../../../../types/common/SelfInput';
import useUpdateInfo from '../../../../../hooks/estimate/common/useUpdateInfo';
import {
  otherBankPeriodInfoState,
  otherBankSelfPeriodInfoState,
} from '../../../../../data/estimate/common/otherBank/info/atom';
import useFetchOtherBank from '../../../../../hooks/estimate/common/fetch/useFetchOtherBank';

const Base = styled.div`
  display: inline-flex;
  align-items: center;
`;

// 고정 기간값
const MONTH_LIST: number[] = [12, 24, 36, 48, 60, 72, 84, 96, 108, 120];

/**
 *  타금융사 할부조건 기간 select 컴포넌트
 *  */
function OtherBankPeriod(): JSX.Element {
  // selected
  const originValue: number = useRecoilValue(otherBankInfoState({ name: 'otherBankPeriod' }));
  const selfPeriod: SelfInputForNumber = useRecoilValue(
    otherBankInfoState({ name: 'otherBankSelfPeriod' })
  );
  const { active, number } = selfPeriod;

  // function
  const { updateOtherBankList } = useFetchOtherBank();
  const update = useUpdateInfo(otherBankPeriodInfoState);
  const selfUpdate = useUpdateInfo(otherBankSelfPeriodInfoState);
  const onBlur = (param: number): void => {
    if (param !== originValue) {
      update(param);
      updateOtherBankList({
        inputName: 'period',
        inputValue: param,
      });
    }
  };

  const onBlurSelf = (param: SelfInputForNumber): void => {
    const applyActive: boolean = param.active;
    const applyParam: number = param.number > 120 ? 120 : param.number < 0 ? 1 : param.number;
    if (applyActive !== active || applyParam !== number) {
      selfUpdate({
        active: applyActive,
        number: applyParam,
      });

      updateOtherBankList({
        inputName: 'period',
        inputValue: applyActive ? applyParam : originValue,
      });
    }
  };
  return (
    <Base>
      <CheckSelfForNumberWithSelect
        list={MONTH_LIST}
        originValue={originValue}
        selfValue={number}
        unit='회'
        checked={active}
        update={onBlur}
        updateSelf={onBlurSelf}
        inputWidth='40px'
        notComma
        boxSize='13px'
        selfValuePriority
      />
      {active && <Span>회</Span>}
    </Base>
  );
}

export default OtherBankPeriod;
